import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/jan/olpha',
        name: 'event-public',
        component: () => import('@/views/events/EventItem.vue'),
    },
    {
        path: '/feb20/olpha',
        name: 'event-public-20',
        component: () => import('@/views/events/EventItem.vue'),
    },
    {
        path: '/feb21/olpha',
        name: 'event-public-21',
        component: () => import('@/views/events/EventItem.vue'),
    },
    {
        path: '/may/olpha',
        name: 'event-public-may-10',
        component: () => import('@/views/events/EventItem.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        redirect: {
            path: '/jan/olpha',
        },
    },
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
			}
		} else if (savedPosition) {
			return savedPosition
		} else {
			return {
				left: 0,
				top: 0,
				behavior: 'smooth',
			}
		}
	},
    history: createWebHistory(),
    routes
});

export default router
